import { render } from "./CardDomicilio.vue?vue&type=template&id=87dbcd78&scoped=true"
import script from "./CardDomicilio.vue?vue&type=script&lang=js"
export * from "./CardDomicilio.vue?vue&type=script&lang=js"

import "./CardDomicilio.vue?vue&type=style&index=0&id=87dbcd78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87dbcd78"]])

export default __exports__